import { FC } from 'react';
import { DesignConflictSubsection } from '../types';
import { DesignConflictItemContainer } from './design-conflict-item-container';

export interface DesignConflictSubsectionContainerProps {
  subsection: DesignConflictSubsection;
}

export const DesignConflictSubsectionContainer: FC<(
  DesignConflictSubsectionContainerProps
)> = ({
  subsection
}) => {
  const { icon, items, label } = subsection;

  return (
    <>
      <h5 className="moduleHeader">
        {(!icon) ? null : (
          <i className={`fe icon-${icon}`} />
        )}
        <span title="rootModule" style={{ paddingLeft: '6px' }}>
          {label}
        </span>
      </h5>
      {items.map((item) => {
        return (
          <DesignConflictItemContainer
            key={item.key}
            item={item}
          />
        );
      })}
    </>
  );
};
